import template from './simulated.html';
import controller from './simulated.controller';
import './simulated.scss';

let simulatedComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default simulatedComponent;



// WEBPACK FOOTER //
// ./client/app/pages/simulated/simulated.component.js